import React from "react";

export function PageHeader({ title, subtitle, actions, testId = "page-header" }) {
  return (
    <div data-testid={testId} className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
      <div>
        <h1 className="font-heading font-bold text-2xl sm:text-3xl text-slate-900 tracking-tight">{title}</h1>
        {subtitle && <p className="mt-1.5 text-slate-600">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, sub, icon: Icon, accent = "blue" }) {
  const colors = {
    blue: "bg-blue-50 text-blue-600",
    mint: "bg-emerald-50 text-emerald-600",
    yellow: "bg-amber-50 text-amber-600",
    coral: "bg-rose-50 text-rose-600",
  };
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 ym-card-hover">
      <div className="flex items-center justify-between">
        <span className="text-xs font-bold uppercase tracking-wider text-slate-500">{label}</span>
        {Icon && (
          <div className={`w-9 h-9 rounded-lg grid place-items-center ${colors[accent]}`}>
            <Icon className="h-4 w-4" strokeWidth={2.2} />
          </div>
        )}
      </div>
      <div className="mt-3 font-heading font-black text-3xl text-slate-900">{value}</div>
      {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
    </div>
  );
}

export function EmptyState({ title, desc, icon: Icon }) {
  return (
    <div className="text-center py-16 px-6 border border-dashed border-slate-200 rounded-xl bg-white">
      {Icon && (
        <div className="mx-auto w-12 h-12 rounded-xl bg-blue-50 text-blue-600 grid place-items-center">
          <Icon className="h-6 w-6" />
        </div>
      )}
      <h3 className="mt-4 font-heading font-bold text-lg text-slate-900">{title}</h3>
      {desc && <p className="mt-1 text-sm text-slate-600">{desc}</p>}
    </div>
  );
}

export function Section({ title, children, actions }) {
  return (
    <section className="bg-white border border-slate-200 rounded-xl">
      {(title || actions) && (
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
          {title && <h2 className="font-heading font-bold text-lg text-slate-900">{title}</h2>}
          {actions}
        </div>
      )}
      <div className="p-5">{children}</div>
    </section>
  );
}
